<div class="main_body">
  <app-page-header
    [title]="i18n.toolbar.title"
    icon="manual"
    [subtitle]="i18n.subtitle" />

  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="manual-container">

          <!-- 取扱説明書 -->
          <div class="manual-section">
            <h4 class="manual-section-title">
              <mat-icon class="manual-section-title__icon">menu_book</mat-icon>
              <span i18n="@@home.manual.title.download">取扱説明書</span>
            </h4>

            <div class="manual-card">
              <div class="manual-card__info">
                <span class="manual-card__name">GOKURI Cloud</span>
              </div>
              <a mat-stroked-button
                 href="https://www.gokuri.com/pdf-manual"
                 target="_blank"
                 rel="noopener noreferrer">
                <mat-icon>open_in_new</mat-icon>
                <span i18n="@@home.manual.button.download">マニュアルを見る</span>
              </a>
            </div>
          </div>

          <div class="form-divider"></div>

          <!-- よくある質問 -->
          <div class="manual-section">
            <h4 class="manual-section-title">
              <mat-icon class="manual-section-title__icon">help_outline</mat-icon>
              <span i18n="@@home.manual.title.faq">よくある質問</span>
            </h4>

            <mat-accordion class="manual-faq-accordion">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <dt i18n="@@home.manual.faq.q1"><span class="faq_q">Q<span class="num">1</span>. </span>セクションとは何でしょうか？セクションは追加できますか？</dt>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <span class="faq_a">A</span>
                <p class="faq_ans" i18n="@@home.manual.faq.a1">セクションは、病院・施設・診療科・チームなど、GOKURIを利用する単位です。セクションを管理する権限を持つセクショングループ管理者は、グループ管理画面の「セクション」からセクションを追加・変更・停止できます。権限がない場合は、セクショングループ管理者にお問い合わせください。</p>
              </mat-expansion-panel>

              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <dt i18n="@@home.manual.faq.q2"><span class="faq_q">Q<span class="num">2</span>. </span>スタッフ・ユーザーとは何でしょうか？スタッフ・ユーザーは追加できますか？</dt>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <span class="faq_a">A</span>
                <p class="faq_ans" i18n="@@home.manual.faq.a2">スタッフは、ネックバンドやアプリケーションを操作して計測する方（主に医療従事者など）です。ユーザーは、患者や入居者などの計測対象者です。スタッフを管理する権限を持つスタッフはスタッフを、一般ユーザーを管理する権限を持つスタッフはユーザーを、スタッフメニューから追加・変更できます。</p>
              </mat-expansion-panel>

              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <dt i18n="@@home.manual.faq.q3"><span class="faq_q">Q<span class="num">3</span>. </span>マニュアルで解決しない問い合わせはどうしたらいいですか？</dt>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <span class="faq_a">A</span>
                <p class="faq_ans" i18n="@@home.manual.faq.a3">マニュアルで解決しないお問い合わせは、以下のサポートページからお願いします。<br>
                  <a [routerLink]="['/section-admin', selectedSectionId, 'support']">→ サポートページ</a>
                </p>
              </mat-expansion-panel>
            </mat-accordion>
          </div>

        </div>
      </section>
    </div>
  </div>
</div>
